import React from 'react';
import { Row } from 'react-bootstrap';
import { FormCol, FormFilterCard, FieldInput, FieldSelectIsActive } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { useRootStore } from 'store';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ name: likeObj }, { address: likeObj }, { city: likeObj }, { postalcode: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (Επωνυμία Δ.Ο.Υ, Διεύθυνση, Πόλη)')}
          type="search"
          disable={disable}
        />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
      </Row>
    </FormFilterCard>
  );
};

export default Filters;
